import { create } from 'zustand'

import { createSelectors } from './helpers'

export enum LayoutTheme {
  UI = 'ui',
  QUEST = 'quest',
}

interface AppStore {
  isLoading: boolean
  isRendered: boolean
  feedback: null
  refresh: number
  isFollowedRefresh: boolean
  actions: {
    setIsRendered: (isRendered: boolean) => void
    setThemeColor: (layoutTheme: LayoutTheme) => void
    setIsLoading: (isLoading: boolean) => void
    incrementRefresh: () => void
    followRefresh: () => void
  }
  layoutTheme: LayoutTheme
}

export const useAppStoreBase = create<AppStore>((set, get) => ({
  isLoading: false,
  isRendered: false,
  feedback: null,
  refresh: 0,
  isFollowedRefresh: false,
  actions: {
    showFeedback: () => {},
    setIsRendered: (isRendered: boolean) => set({ isRendered }),
    setThemeColor: (layoutTheme: LayoutTheme) => set({ layoutTheme }),
    setIsLoading: (isLoading) => set(() => ({ isLoading })),
    incrementRefresh: () =>
      set((state) => ({
        refresh: state.refresh + 1,
        isFollowedRefresh: false,
      })),
    followRefresh: () => set({ isFollowedRefresh: true }),
  },
  layoutTheme: LayoutTheme.UI,
}))

export const useAppActions = () => useAppStoreBase((state) => state.actions)
export const useAppIsLoadingState = () =>
  useAppStoreBase((state) => state.isLoading)
export const useAppRefresh = () => useAppStoreBase((state) => state.refresh)
export const useAppIsFollowedRefresh = () =>
  useAppStoreBase((state) => state.isFollowedRefresh)

export const useApp = createSelectors(useAppStoreBase)
